import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
    nonAdminUser: state.authReducer.nonAdminUser
});

export const withSubordinateUser = (WrappedComponent) => {
    const WithSubordinateUser = ({ nonAdminUser, ...props }) =>  <WrappedComponent nonAdminUser={nonAdminUser} {...props} />;

    WithSubordinateUser.propTypes = {
        nonAdminUser: PropTypes.bool
    };

    return WithSubordinateUser;
};

export default WrapperComponent => connect(mapStateToProps, null)(withSubordinateUser(WrapperComponent));
